import { PlaneComponent } from './../../components/plane/plane.component';
import { EntityModel } from './../../model';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Optional,
} from '@angular/core';
import { MouseEntityService, EntityDragEvent } from './mouse-entity.service';
import { Object3D } from 'three';
import { Ng3MosueWheelEvent } from './mouse-canvas.service';
import { EntityComponent } from '../../components/share/entity-component';

@Component({
  selector: 'ng3-mouse-entity',
  templateUrl: './mouse-entity.component.html',
  styleUrls: ['./mouse-entity.component.css'],
  providers: [MouseEntityService],
})
export class MouseEntityComponent implements OnInit, OnDestroy {
  constructor(
    private mouse: MouseEntityService,
    // private entity: EntityService,
    @Optional() private entity2: EntityComponent<EntityModel>
  ) {
    this.mouse.click$.subscribe(
      () => {
        // console.log(this.entity2.entity );
        // if (this.entity.entity !== undefined) {
        //   this.click.emit(this.entity.entity);
        // }
        if (this.entity2.entity !== undefined) {
          this.click.emit(this.entity2.entity);
        }
      },
      (e) => console.error(e),
    );
    this.mouse.drag$.subscribe(
      (d) => {
        this.drag.emit(d);
      },
      (e) => console.error(e),
    );
    this.mouse.hover$.pipe().subscribe(
      (h) => {
        this.hover.emit(h);
      },
      (e) => console.error(e),
    );
    this.mouse.wheel$.subscribe(
      (e) => this.wheel.emit(e),
      (e) => console.error(e),
    );
  }

  @Output()
  click = new EventEmitter<Object3D>();

  @Output()
  drag = new EventEmitter<EntityDragEvent>();

  @Output()
  hover = new EventEmitter<boolean>();

  @Output()
  wheel = new EventEmitter<Ng3MosueWheelEvent>();

  ngOnInit() {}
  ngOnDestroy() {}
}
